<template>
  <div>
    <label class="vs-input--label">{{ `${field.required ? '*' : ''}${field.label}` }}</label>
    <datepicker
      v-if="field.type === 'date'"
      v-model="fieldValue"
      :format="dateFormatter"

    ></datepicker>
    <vs-checkbox
      v-else-if="field.type === 'boolean'"
      v-model="fieldValue"
    ></vs-checkbox>
    <v-select
      v-else-if="field.type === 'options'"
      :options="field.options"
      v-model="fieldValue"
    />
    <vs-input
      v-else-if="field.type === 'text'"
      name="textValue"
      type="text"
      v-model="fieldValue"
      v-validate="'required'"
    />
    <vs-input
      v-else-if="field.type === 'number'"
      name="numberValue"
      type="number"
      v-model="fieldValue"
      v-validate="'required'"
    />
    
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { mapMutations } from 'vuex';
import moment from 'moment';

export default {
  name: "SetValue",
  components: {
    Datepicker,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  created: function () {
    // set true boolean fields and update them in the store state
    // this way is easier to handling it.
    // e.g. Admin adds a user not vaccinated
    // value = false
    // he never clicked the checkbox
    // value will never get updated in vuex
    if (this.field.type === "boolean") {
      this.fieldValue = true;
    }
  },
  methods: {
    ...mapMutations("customFields", ["UPDATE_USER_FIELD"]),
    dateFormatter (date) {
      // javascript always transforms a local date time to UTC after JSONify a Date object
      // https://stackoverflow.com/questions/31096130/how-to-json-stringify-a-javascript-date-and-preserve-timezone

      // toJSON will be executed by axios (not shure) when the payload is generated and we preserve our local datetime
      // #Hackish
      date.toJSON = function() {
        return moment(this).format('YYYY-MM-DD');
      };
      return moment(date).format('YYYY-MM-DD');
    }
  },
  computed: {
    fieldValue: {
      // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
      get() {
        return this.$store.state.customFields.fields.find(
          (f) => f.id === this.field.id
        ).value;
      },
      set(value) {
        this.UPDATE_USER_FIELD({ ...this.field, value: value });
      },
    },
  },
};
</script>
